import { API_ORIGIN } from '../../config/endpoints.js';

/** Same host as slot hub; path `translation/translations` matches Yogames launcher API. */
const DEFAULT_TRANSLATIONS_API = `${API_ORIGIN}/api/`;
const DEFAULT_GAME_NAME = 'FruityJungle';

function normalizeTranslationsPayload(data) {
  if (data == null || typeof data !== 'object') return null;
  const root = data;
  const inner =
    (root.result && typeof root.result === 'object' ? root.result : null) ??
    (root.Result && typeof root.Result === 'object' ? root.Result : null) ??
    (root.translations && typeof root.translations === 'object' ? root.translations : null) ??
    (root.data && typeof root.data === 'object' ? root.data : null);

  if (inner && !Array.isArray(inner)) {
    const out = {};
    for (const [key, value] of Object.entries(inner)) {
      if (typeof value === 'string') out[key] = value;
    }
    return Object.keys(out).length ? out : null;
  }

  if (Array.isArray(inner)) {
    const out = {};
    for (const row of inner) {
      if (row && typeof row === 'object') {
        const key = row.key ?? row.Key ?? row.keyword ?? row.Keyword;
        const value = row.value ?? row.Value;
        if (typeof key === 'string' && typeof value === 'string') out[key] = value;
      }
    }
    return Object.keys(out).length ? out : null;
  }

  const flat = {};
  for (const [key, value] of Object.entries(root)) {
    if (typeof value === 'string') flat[key] = value;
  }
  return Object.keys(flat).length ? flat : null;
}

function apiBase() {
  const configured = import.meta.env.VITE_CRYPTOGAMES_API_URL ?? DEFAULT_TRANSLATIONS_API;
  const trimmed = String(configured).trim();
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
}

export function getParamsFromUrl(search) {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const normalized = raw.includes('?') ? raw.replace(/\?/g, '&') : raw;
  const params = new URLSearchParams(normalized);
  const result = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
}

export async function loadTranslations({
  accessToken,
  gameName,
  culture,
  translationStore,
  signal,
} = {}) {
  const url = new URL('translation/translations', apiBase());
  url.searchParams.set('GameName', gameName?.trim() || DEFAULT_GAME_NAME);
  url.searchParams.set('Culture', culture?.trim() || 'en');

  try {
    const headers = {};
    if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
    const response = await fetch(url.toString(), {
      headers,
      credentials: 'omit',
      signal,
    });
    if (!response.ok) {
      translationStore?.setTranslations({});
      translationStore?.setTranslationsFetchOk(true);
      return;
    }
    const map = normalizeTranslationsPayload(await response.json());
    translationStore?.setTranslations(map ?? {});
    translationStore?.setTranslationsFetchOk(true);
  } catch (err) {
    if (err?.name === 'AbortError') throw err;
    translationStore?.setTranslations({});
    translationStore?.setTranslationsFetchOk(true);
  }
}
